import KunLoading13 from './src/index'

KunLoading13.install = function (Vue) {
	Vue.component(KunLoading13.name, KunLoading13);
}

export default KunLoading13;
